// src/utils/crypto.util.js
import CryptoJS from "crypto-js";

/**
 * Encrypt any string data using AES encryption.
 * @param {string} data - The string to encrypt.
 * @param {string} secretKey - Optional: Custom secret key. Defaults to REACT_APP_ENCRYPTION_SECRET.
 * @returns {string} - Encrypted ciphertext.
 */
export const encryptData = (data, secretKey = process.env.REACT_APP_ENCRYPTION_SECRET) => {
  try {
    return CryptoJS.AES.encrypt(data, secretKey).toString();
  } catch (error) {
    throw new Error(`Encryption failed: ${error.message}`);
  }
};

/**
 * Decrypt AES-encrypted string data.
 * @param {string} cipherText - The encrypted string.
 * @param {string} secretKey - Optional: Custom secret key. Defaults to REACT_APP_ENCRYPTION_SECRET.
 * @returns {string} - Decrypted plain text.
 */
export const decryptData = (cipherText, secretKey = process.env.REACT_APP_ENCRYPTION_SECRET) => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, secretKey);
    return bytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    throw new Error(`Decryption failed: ${error.message}`);
  }
};
